module.exports = __webpack_public_path__ + "img/icon-science.5a1590ec.png";